import React from 'react';
import { Chart } from 'react-google-charts';

const data = [
    [
        { type: 'date', label: 'Month' },
        'Line 1',
        { role: 'interval' },
        { role: 'interval' },
        'Line 2',
        { role: 'interval' },
        { role: 'interval' },
        'Line 3',
        { role: 'interval' },
        { role: 'interval' },
    ],
    [new Date(2023, 0), 0.1, 0.08, 0.12, 0.4, 0.35, 0.45, 0.3, 0.25, 0.35],
    [new Date(2023, 1), 0.15, 0.12, 0.18, 0.5, 0.45, 0.55, 0.35, 0.3, 0.4],
    [new Date(2023, 2), 0.2, 0.18, 0.22, 0.6, 0.55, 0.65, 0.4, 0.35, 0.45],
    [new Date(2023, 3), 0.25, 0.22, 0.28, 0.7, 0.65, 0.75, 0.45, 0.4, 0.5],
    [new Date(2023, 4), 0.3, 0.28, 0.32, 0.75, 0.7, 0.8, 0.5, 0.45, 0.55],
    [new Date(2023, 5), 0.35, 0.32, 0.38, 0.8, 0.75, 0.85, 0.55, 0.5, 0.6],
    [new Date(2023, 6), 0.4, 0.38, 0.42, 0.75, 0.7, 0.8, 0.6, 0.55, 0.65],
    [new Date(2023, 7), 0.45, 0.42, 0.48, 0.7, 0.65, 0.75, 0.65, 0.6, 0.7],
    [new Date(2023, 8), 0.5, 0.48, 0.52, 0.65, 0.6, 0.7, 0.7, 0.65, 0.75],
    [new Date(2023, 9), 0.55, 0.52, 0.58, 0.6, 0.55, 0.65, 0.75, 0.7, 0.8],
    [new Date(2023, 10), 0.6, 0.58, 0.62, 0.55, 0.5, 0.6, 0.8, 0.75, 0.85],
    [new Date(2023, 11), 0.65, 0.62, 0.68, 0.5, 0.45, 0.55, 0.75, 0.7, 0.8],
];


const options = {
    title: 'Biodiversity Monitoring',
    curveType: "function",
    legend: { position: "bottom" },
    hAxis: {
        title: 'Month',
        format: 'MMM yyyy',
    },
    vAxis: {
        title: 'Values',
        minValue: 0.1,
        maxValue: 0.8,
    },
    intervals: {
        style: 'area',
        areaOpacity: 0.2,
    },
    series: {
        0: { color: '#e2431e' },
        1: { color: '#6f9654' },
        2: { color: '#1c91c0' },
    },
};

const BiodiversityMonitoring = () => {
    return (
        <div style={{ width: '100%' }}>
            <Chart
                chartType="LineChart"
                width="100%"
                height="400px"
                data={data}
                options={options}
            />
        </div>
    );
};

export default BiodiversityMonitoring;
